export default {
	"home.AnErrorHasOccurredPleaseContactTheInstructorForTheScreenshot": "发生错误了，请截图联系指导师",
	"home.MarketingMarketplaceHomePage": "营销商城主页",
	"home.MarketingMarketplace": "营销商城"
}